import { VImg } from 'vuetify/lib/components/VImg';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRating } from 'vuetify/lib/components/VRating';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VList,{staticStyle:{"background":"transparent"}},[_c(VListItem,{staticClass:"px-0"},[_c('div',{staticClass:"text-align-end",staticStyle:{"flex-grow":"1"}},[_c(VListItemAvatar,{staticClass:"my-auto",attrs:{"size":76}},[_c(VImg,{attrs:{"src":_vm.review.img}})],1)],1),_vm._v(" "),_c(VListItemContent,{staticClass:"text-align-start",staticStyle:{"flex-grow":"18"}},[_c(VRating,{staticClass:"mb-0",attrs:{"value":5,"dense":"","color":"yellow darken-3"}}),_vm._v(" "),_c(VListItemTitle,{class:[
                    _vm.$vuetify.breakpoint.smAndDown
                        ? 'text-body-2'
                        : 'text-h6',
                    'pa-1 white--text ',
                ],staticStyle:{"white-space":"normal"}},[_vm._v(_vm._s(_vm.review.content))]),_vm._v(" "),_c(VListItemSubtitle,{class:[
                    _vm.$vuetify.breakpoint.smAndDown ? null : 'text-body-2',
                    'white--text',
                ]},[_vm._v("- "+_vm._s(_vm.review.user)+"\n            ")])],1)],1)],1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }